var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 7.60152C5.2998 6.46109 5.7528 5.36737 6.5592 4.56096C7.36561 3.75456 8.45936 3.3015 9.59979 3.3015C10.2024 3.2916 10.8001 3.41153 11.3522 3.6531C11.9044 3.89466 12.3981 4.25224 12.7998 4.70153V4.50152C12.7998 3.57326 13.1685 2.68301 13.8249 2.02663C14.4813 1.37025 15.3715 1.00152 16.2998 1.00152C16.7632 0.987674 17.2245 1.06874 17.6554 1.23974C18.0863 1.41073 18.4777 1.66803 18.8055 1.99584C19.1333 2.32364 19.3906 2.71503 19.5616 3.14593C19.7326 3.57682 19.8136 4.03814 19.7998 4.50152V4.70153C20.3974 4.06761 21.1698 3.62535 22.019 3.43084C22.8682 3.23632 23.756 3.29829 24.57 3.60888C25.384 3.91947 26.0874 4.46471 26.5912 5.1755C27.095 5.88628 27.3764 6.73063 27.3998 7.60152",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 7.60152C5.2998 6.46109 5.7528 5.36737 6.5592 4.56096C7.36561 3.75456 8.45936 3.3015 9.59979 3.3015C10.2024 3.2916 10.8001 3.41153 11.3522 3.6531C11.9044 3.89466 12.3981 4.25224 12.7998 4.70153V4.50152C12.7998 3.57326 13.1685 2.68301 13.8249 2.02663C14.4813 1.37025 15.3715 1.00152 16.2998 1.00152C16.7632 0.987674 17.2245 1.06874 17.6554 1.23974C18.0863 1.41073 18.4777 1.66803 18.8055 1.99584C19.1333 2.32364 19.3906 2.71503 19.5616 3.14593C19.7326 3.57682 19.8136 4.03814 19.7998 4.50152V4.70153C20.3974 4.06761 21.1698 3.62535 22.019 3.43084C22.8682 3.23632 23.756 3.29829 24.57 3.60888C25.384 3.91947 26.0874 4.46471 26.5912 5.1755C27.095 5.88628 27.3764 6.73063 27.3998 7.60152",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 30.1015L9.69995 19.5015L3 8.90151C11.7639 6.70019 20.9361 6.70019 29.7 8.90151L23 19.5015L16.3 30.1015Z",
    fill: "url(#paint0_linear_20_198)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3002 15.0015C14.46 15.0015 15.4002 14.0613 15.4002 12.9015C15.4002 11.7417 14.46 10.8015 13.3002 10.8015C12.1404 10.8015 11.2002 11.7417 11.2002 12.9015C11.2002 14.0613 12.1404 15.0015 13.3002 15.0015Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 15.4015C21.9387 15.4015 22.6998 14.6404 22.6998 13.7015C22.6998 12.7627 21.9387 12.0015 20.9998 12.0015C20.0609 12.0015 19.2998 12.7627 19.2998 13.7015C19.2998 14.6404 20.0609 15.4015 20.9998 15.4015Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3001 21.6015C17.239 21.6015 18.0001 20.8404 18.0001 19.9015C18.0001 18.9626 17.239 18.2015 16.3001 18.2015C15.3612 18.2015 14.6001 18.9626 14.6001 19.9015C14.6001 20.8404 15.3612 21.6015 16.3001 21.6015Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_198",
    x1: 29.7,
    y1: 30.1015,
    x2: 7.12305,
    y2: 3.72183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3AF00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.0e410b2c8b86ea750b9d6f3db71732d7.svg";
export { ForwardRef as ReactComponent };